// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"248":"ce894de7","318":"136c764b","440":"3a6d1729","587":"62c62fa9","823":"2b8b6c35"}[chunkId] + ".js";
};